<template>
  <div :class="{ 'md:mx-14 pt-4 mx-5': !hasLimitedSettings }">
    <div>
      <div>
        <div class="flex">
          <div @click="showViewType('grid')">
            <grid-icon class="mr-4 cursor-pointer" />
          </div>
          <div @click="showViewType('list')">
            <list-icon class="cursor-pointer" />
          </div>
        </div>
        <!-- Settings Grid Page-->
        <div
          :class="
            gridType
              ? 'grid md:grid-cols-12 grid-cols-1 gap-5  mt-8 w-full'
              : 'w-full mt-6'
          "
        >
          <div
            @click="showNextPage('Profile')"
            :class="
              gridType
                ? 'md:col-span-3 cursor-pointer'
                : 'flex items-center cursor-pointer justify-between mb-5 pl-6 pr-6 box-2 md:w-1/2'
            "
          >
            <div
              :class="
                gridType
                  ? 'border flex flex-col items-center justify-center box'
                  : 'flex flex-row items-center'
              "
            >
              <user-icon />
              <p
                :class="
                  gridType
                    ? 'text-root-4 text-base font-normal mt-6'
                    : 'ml-6 text-lg font-normal text-root-4'
                "
              >
                Profile
              </p>
            </div>
            <arrow-right-icon v-if="!gridType" />
          </div>
          <el-tooltip
            class="item"
            effect="light"
            :disabled="!isUserKindViewOnly"
            :content="'No access to get withdrawal methods'"
            placement="bottom"
          >
            <div
              @click="showNextPage('WithdrawalMethod')"
              :class="[
                gridType
                  ? 'md:col-span-3 cursor-pointer'
                  : 'flex items-center cursor-pointer justify-between mb-5 pl-6 pr-6 box-2 md:w-1/2',
                isUserKindViewOnly
                  ? 'cursor-not-allowed opacity-30'
                  : 'cursor-pointer'
              ]"
            >
              <div
                :class="
                  gridType
                    ? 'border flex flex-col items-center justify-center box'
                    : 'flex flex-row items-center'
                "
              >
                <bank-icon-big />
                <p
                  :class="
                    gridType
                      ? 'text-root-4 text-base font-normal mt-6'
                      : 'ml-6 text-lg font-normal text-root-4'
                  "
                >
                  Withdrawal Method
                </p>
              </div>
              <arrow-right-icon v-if="!gridType" />
            </div>
          </el-tooltip>
          <div
            @click="showNextPage('Security')"
            :class="
              gridType
                ? 'md:col-span-3 cursor-pointer'
                : 'flex items-center cursor-pointer justify-between mb-5 pl-6 pr-6 box-2 md:w-1/2'
            "
          >
            <div
              :class="
                gridType
                  ? 'border flex flex-col items-center justify-center box'
                  : 'flex flex-row items-center'
              "
            >
              <security-icon />
              <p
                :class="
                  gridType
                    ? 'text-root-4 text-base font-normal mt-6'
                    : 'ml-6 text-lg font-normal text-root-4'
                "
              >
                Security
              </p>
            </div>
            <arrow-right-icon v-if="!gridType" />
          </div>
          <div
            v-if="hasApiAccess"
            @click="showNextPage('APIKeysAndWebhooks')"
            :class="
              gridType
                ? 'md:col-span-3 cursor-pointer'
                : 'flex items-center cursor-pointer justify-between mb-5 pl-6 pr-6 box-2 md:w-1/2'
            "
          >
            <div
              :class="
                gridType
                  ? 'border flex flex-col items-center justify-center box'
                  : 'flex flex-row items-center'
              "
            >
              <key-icon />
              <p
                :class="
                  gridType
                    ? 'text-root-4 text-base font-normal mt-6'
                    : 'ml-6 text-lg font-normal text-root-4'
                "
              >
                API Keys & Webhooks
              </p>
            </div>
            <arrow-right-icon v-if="!gridType" />
          </div>
          <!-- <div @click="showNextPage('IPWhitelisting')" class="cursor-not-allowed" :class="gridType ? 'md:col-span-3 cursor-pointer' : 'flex items-center cursor-pointer justify-between mb-5 pl-6 pr-6 box-2 md:w-1/2'">
          <div :class="gridType  ? 'border flex flex-col items-center justify-center box' : 'flex flex-row items-center'">
            <location-icon/>
            <p :class="gridType ? 'text-root-4 text-base font-normal mt-6' : 'ml-6 text-lg font-normal text-root-4'">IP Whitelisting</p>
          </div>
          <arrow-right-icon  v-if="!gridType" />
        </div> -->
          <div
            v-if="isUserKindOwner"
            @click="showNextPage('UserManagement')"
            :class="
              gridType
                ? 'md:col-span-3 cursor-pointer'
                : 'flex items-center cursor-pointer justify-between mb-5 pl-6 pr-6 box-2 md:w-1/2'
            "
          >
            <div
              :class="
                gridType
                  ? 'border flex flex-col items-center justify-center box'
                  : 'flex flex-row items-center'
              "
            >
              <people-icon />
              <p
                :class="
                  gridType
                    ? 'text-root-4 text-base font-normal mt-6'
                    : 'ml-6 text-lg font-normal text-root-4'
                "
              >
                User Management
              </p>
            </div>
            <arrow-right-icon v-if="!gridType" />
          </div>
          <el-tooltip
            class="item"
            effect="light"
            :disabled="!isUserKindViewOnly"
            :content="'No access to view contracts'"
            placement="bottom"
          >
            <div
              @click="showNextPage('Contract')"
              v-if="!isManualKycType"
              :class="[
                gridType
                  ? 'md:col-span-3 cursor-pointer'
                  : 'flex items-center cursor-pointer justify-between mb-5 pl-6 pr-6 box-2 md:w-1/2',
                isUserKindViewOnly
                  ? 'cursor-not-allowed opacity-30'
                  : 'cursor-pointer'
              ]"
            >
              <div
                :class="
                  gridType
                    ? 'border flex flex-col items-center justify-center box'
                    : 'flex flex-row items-center'
                "
              >
                <notes-icon />
                <p
                  :class="
                    gridType
                      ? 'text-root-4 text-base font-normal mt-6'
                      : 'ml-6 text-lg font-normal text-root-4'
                  "
                >
                  Contracts
                </p>
              </div>
              <arrow-right-icon v-if="!gridType" />
            </div>
          </el-tooltip>
          <div
            v-if="isOnDevEnvironment && hasDepositAccess"
            @click="showNextPage('Terminal')"
            :class="
              gridType
                ? 'md:col-span-3 cursor-pointer'
                : 'flex items-center cursor-pointer justify-between mb-5 pl-6 pr-6 box-2 md:w-1/2'
            "
          >
            <div
              :class="
                gridType
                  ? 'border flex flex-col items-center justify-center box'
                  : 'flex flex-row items-center'
              "
            >
              <terminal-icon-two />
              <p
                :class="
                  gridType
                    ? 'text-root-4 text-base font-normal mt-6'
                    : 'ml-6 text-lg font-normal text-root-4'
                "
              >
                Terminal
              </p>
            </div>
            <arrow-right-icon v-if="!gridType" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import userKinds from '@/mixins/userKinds.js'

export default {
  mixins: [userKinds],
  components: {
    GridIcon: () => import('@/assets/icons/GridIcon.vue'),
    ListIcon: () => import('@/assets/icons/ListIcon.vue'),
    UserIcon: () => import('@/assets/icons/UserIcon.vue'),
    BankIconBig: () => import('@/assets/icons/BankIconBig.vue'),
    SecurityIcon: () => import('@/assets/icons/SecurityIcon.vue'),
    KeyIcon: () => import('@/assets/icons/KeyIcon.vue'),
    // LocationIcon: () => import('@/assets/icons/LocationIcon.vue'),
    PeopleIcon: () => import('@/assets/icons/PeopleIcon.vue'),
    NotesIcon: () => import('@/assets/icons/NotesIcon.vue'),
    TerminalIconTwo: () => import('@/assets/icons/TerminalIconTwo.vue'),
    ArrowRightIcon: () => import('@/assets/icons/ArrowRightIcon.vue')
  },
  methods: {
    showViewType (viewType) {
      this.$store.dispatch('common/setViewType', viewType)
    },
    showNextPage (page) {
      if (
        (page === 'Contract' || page === 'WithdrawalMethod') &&
        this.isUserKindViewOnly
      ) {
        this.$notify.error({
          title: 'Access denied',
          position: 'top-right'
        })
        return
      }
      if (page === 'Profile') {
        this.$router.push('/settings/profile')
      } else if (page === 'WithdrawalMethod') {
        this.$router.push('/settings/withdrawal-method')
      } else if (page === 'Security') {
        this.$router.push('/settings/security')
      } else if (page === 'APIKeysAndWebhooks') {
        this.$router.push('/settings/api-keys-and-webhooks')
      } else if (page === 'UserManagement') {
        this.$router.push('/settings/user-management')
      } else if (page === 'Contract') {
        this.$router.push('/settings/contracts')
      } else if (page === 'Terminal') {
        this.$router.push('/settings/terminal')
      } else if (page === 'IPWhitelisting') {
        this.$router.push('/settings/ip-whitelisting')
      }
    },
    goBack () {
      this.$router.push('/settings')
    },
    getApiCredentials () {
      const vm = this
      this.$store
        .dispatch('externalApi/getApiCredentials')
        .then(() => {})
        .catch((error) => {
          const err = error.response
            ? error.response.data.error.publicMessage
            : error
          vm.$message({
            showClose: true,
            message: this.httpErrorMessage,
            type: 'error'
          })
        })
        .finally(() => {})
    }
  },
  computed: {
    isOnDevEnvironment () {
      return process.env.NODE_ENV !== 'production'
    },
    isManualKycType () {
      return this.$store.state.auth.business.kycType === 'manual'
    },
    gridType () {
      return this.$store.state.common.viewType === 'grid'
    },
    hasApiConfig () {
      return !!this.$store.state.auth.businessConfig.has_api_config
    },
    hasLimitedSettings () {
      return process.env.VUE_APP_SETTINGS_LIMITED === 'true'
    },
    user () {
      return this.$store.state.auth.user
    },
    hasApiAccess () {
      return process.env.VUE_APP_API_ACCESS === 'true' && this.hasApiConfig
    }
  },
  mounted () {
    this.getApiCredentials()
  }
}
</script>

<style scoped>
.box {
  box-shadow:
    0px 0px 1px rgba(3, 2, 7, 0.12),
    0px 2px 4px rgba(3, 2, 7, 0.12);
  border-radius: 15px;
  height: 200px;
}
.box-2 {
  height: 87px;
  box-shadow:
    0px 0px 1px rgba(3, 2, 7, 0.12),
    0px 2px 4px rgba(3, 2, 7, 0.12);
  border-radius: 15px;
}
</style>
